import { FC } from 'react';
import { Controller, UseControllerProps } from 'react-hook-form';

import StyledTextInput, { ITextInputProps } from './index';

const FormTextInput: FC<UseControllerProps<ITextInputProps>> = props => {
  const { name, control } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <StyledTextInput
            error={fieldState.error?.message}
            {...field}
            {...props}
          />
        );
      }}
    />
  );
};
export default FormTextInput;
